import classNames from 'classnames'
import { createUseStyles, useTheme } from 'react-jss'
import wpautop from 'wpautop'
import LazyImage from '@/components/LazyImage'
import BtnLink from '@/components/BtnLink'
import style from './style'

const useStyles = createUseStyles(style)

const ParallaxText = ({
  data,
  className,
}) => {
  const randomID = Math.floor(Math.random() * 10000)
  const theme = useTheme()
  const classes = useStyles()

  /*------------------------------
  Render
  ------------------------------*/
  return (
    <div
      id={`id-${randomID}`}
      className={classNames({
        [classes.parallaxRoot]: true,
        [className]: true,
        [classes.parallaxVirtual]: !theme.detect.isNativeScroll,
      })}
    >
      <div
        className={classes.parallaxText}
        data-scroll
        data-scroll-speed="-7"
        data-scroll-offset="-900%"
      >
        <div
          dangerouslySetInnerHTML={{ __html: data.text }}
        />
        {data.link && (
          <div className={classes.cta}>
            <BtnLink
              label={data.label || 'Discover'}
              link={data.link}
              theme="quicksand"
            />
          </div>
        )}
      </div>
      {data.img1 && (
        <LazyImage
          className={`${classes.parallaxImg} parallax-img-1`}
          src={data.img1}
        />
      )}
      {data.img2 && (
        <LazyImage
          className={`${classes.parallaxImg} parallax-img-2`}
          src={data.img2}
        />
      )}
      {data.img3 && (
        <LazyImage
          className={`${classes.parallaxImg} parallax-img-3`}
          src={data.img3}
        />
      )}
      {data.img4 && (
        <LazyImage
          className={`${classes.parallaxImg} parallax-img-4`}
          src={data.img4}
        />
      )}
      {data.img5 && (
        <LazyImage
          className={`${classes.parallaxImg} parallax-img-5`}
          src={data.img5}
        />
      )}
    </div>
  )
}

export default ParallaxText
